import React from "react";
import {getMenuById} from "./ClientMenuQueries";
import PageTitle from "../../../layout/PageTitle";
import {useQuery} from "@apollo/client";
import {tableImageTag} from "../../../helpers/Api";
import {useParams} from "react-router-dom";
import ClientPlatesList from "../plates/ClientPlatesList";
import ShowMoreText from "react-show-more-text";
import Loader from "../../shared/Loader";

const ClientMenuDetails = () => {
  const params = useParams();
  const { loading, data, refetch } = useQuery(getMenuById, { variables: { id: params.id } })
  const menu = !loading && data.menu

  return (
    <>
      <div>
        <PageTitle title={menu.name}
                   image={tableImageTag(menu, { width: 35, height: 'auto', className: 'rounded', type: 'menu' })}
                   hasSeparator={!menu.details}
        />
        <input type='hidden' name='id' id="id" defaultValue={menu.id} />

        {menu.details &&
          <ShowMoreText lines={1}
                        anchorClass={"text-branding pointer fs-7"}
                        className="mb-2 pb-3 text-dark html_escape"
                        more="Toata descrierea"
                        less="Mai putin text"
          >{menu.details}</ShowMoreText>
        }
      </div>

      {loading ?
        <Loader />
        :
        <ClientPlatesList menu={menu} refetch={refetch}></ClientPlatesList>
      }
    </>
  )
};

export default ClientMenuDetails;
